import module from 'recursoshumanos/module.js'
import template from './template.html'

export class RecursoshumanosPagosSuaLista {
  data
  onSelect

  seleccionarMultiple (items, seleccionado) {
    items.forEach(item => (item.seleccionado = seleccionado))
    this.onSelect();
  }
}

module.component('recursoshumanosPagosSuaLista', {
  controller: RecursoshumanosPagosSuaLista,
  template,
  bindings: {
    data: '<',
    bimestral: '<',
    onSelect: '&',
  }
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/pagossua/lista/component.js